// src/components/app-shell/styles.ts
import { css } from 'lit'

export const styles = css`
    :host {
        display: flex;
        flex-direction: column;
        height: 100dvh;
        background-color: var(--bg-primary);
        color: var(--text-primary);
        transition:
            background-color var(--transition-normal),
            color var(--transition-normal);
    }
`
